module.exports = __webpack_public_path__ + "static/media/six.904cc23d.png";